import Resizer from 'react-image-file-resizer'
import logger from '../../../../../../../../../lib/logger'

class ImageParsing {
  constructor(file) {
    this.file = file
  }

  parse() {
    // If it's a WebP or GIF, return the original file
    if (this.file.type === 'image/webp' || this.file.type === 'image/gif') {
      return this.file
    }

    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        this.file,
        1024,
        1024,
        'JPEG',
        100,
        0,
        (uri) => {
          resolve(uri)
        },
        'blob',
        (error) => {
          logger.error('ImageParsing error:', error)
          resolve(null)
        }
      )
    })
  }
}
export default ImageParsing
